export const TYPES_TAGS = { SPAN: 'SPAN' }
